/**
 * Copyright Mántum All Rights Reserved.
 */
import { getDefaultClassNames } from 'react-day-picker';

const defaultClassNames = getDefaultClassNames();

export const getStyle = (mode?: 'range' | 'single') => {
    const selected =
        mode === 'range'
            ? 'bg-primary border-primary text-white rounded-full'
            : 'bg-primary border-primary text-white rounded-md';

    return {
        caption_label: `${defaultClassNames.caption_label} capitalize`,
        chevron: `${defaultClassNames.chevron} !fill-primary`,
        range_end: `rounded-s-md bg-primary`,
        range_middle: `${defaultClassNames.range_middle} rounded-none bg-primary opacity-50`,
        range_start: `rounded-e-md bg-primary`,
        root: `${defaultClassNames.root} p-4`,
        selected,
        today: 'text-primary text-primary'
    };
};
